import React from "react"
import { Box, Typography } from "@mui/material"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import { validatePassword } from "@/utils/password"

const RuleItem = ({ label, status }) => {
  let icon
  let color

  if (status === "pass") {
    icon = <CheckCircleOutlineIcon sx={{ fontSize: 18, color: "#057a55" }} />
    color = "#057a55"
  } else if (status === "fail") {
    icon = <CancelOutlinedIcon sx={{ fontSize: 18, color: "#e02424" }} />
    color = "#e02424"
  } else {
    icon = <RadioButtonUncheckedIcon sx={{ fontSize: 14.4, color: "#d1d5db" }} />
    color = "#111928"
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 18,
          height: 18,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography sx={{ fontSize: 14, lineHeight: 1.5, letterSpacing: "0.35px", color }}>
        {label}
      </Typography>
    </Box>
  )
}

const getRuleStatus = (passed, showErrors) => {
  if (passed) return "pass"
  return showErrors ? "fail" : "default"
}

const getComplexityRuleStatus = (passed, meetsComplexity, showErrors) => {
  if (passed) return "pass"
  if (meetsComplexity) return "default"
  return showErrors ? "fail" : "default"
}

const getAccountRuleStatus = (passed, account, showErrors, sameAsAccountError) => {
  if (sameAsAccountError) return "fail"
  if (!account) return "default"
  if (passed) return "pass"
  return showErrors ? "fail" : "default"
}

const PasswordRules = ({
  password,
  account = "",
  showErrors = false,
  sameAsAccountError = false,
}) => {
  const rules = validatePassword(password, account)

  return (
    <Box
      sx={{
        backgroundColor: "#f9fafb",
        border: "1px solid #e5e7eb",
        borderRadius: "6px",
        p: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        mt: "8px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.5,
            letterSpacing: "0.35px",
            color: "#111928",
          }}
        >
          密碼規則
        </Typography>

        <RuleItem label="長度至少 8 碼" status={getRuleStatus(rules.hasMinLength, showErrors)} />
        <RuleItem
          label="不可與帳號相同"
          status={getAccountRuleStatus(
            rules.notSameAsAccount,
            account,
            showErrors,
            sameAsAccountError
          )}
        />

        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: "0.35px",
            color: "#6b7280",
          }}
        >
          下列四項中至少符合三項
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "6px", pl: "8px" }}>
          <RuleItem
            label="英文大寫 (A-Z)"
            status={getComplexityRuleStatus(rules.hasUppercase, rules.meetsComplexity, showErrors)}
          />
          <RuleItem
            label="英文小寫 (a-z)"
            status={getComplexityRuleStatus(rules.hasLowercase, rules.meetsComplexity, showErrors)}
          />
          <RuleItem
            label="數字 (0-9)"
            status={getComplexityRuleStatus(rules.hasDigit, rules.meetsComplexity, showErrors)}
          />
          <RuleItem
            label="特殊符號 (!@#$%^&* 等)"
            status={getComplexityRuleStatus(rules.hasSpecial, rules.meetsComplexity, showErrors)}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default PasswordRules
